import script from "./ContactScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactScreen.vue?vue&type=script&setup=true&lang=js"

import "./ContactScreen.vue?vue&type=style&index=0&id=f3d54a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3d54a76"]])

export default __exports__